import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-keynote',
  templateUrl: './keynote.component.html',
  styleUrls: ['./keynote.component.css']
})
export class KeynoteComponent implements OnInit {

  @Input() onShowPeriod;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/keynote.component.ts